import UaeMpciApiUrls from 'src/apiUrls/UaeMpciApiUrls'

// Native fetch for blob downloads — avoids cng-web-lib interceptor
// trying to parse blob responses as JSON (causes isOffline IDBTransaction error)
const getAuthHeaders = () => ({
  Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
})

const fetchBlob = (url, onSuccess, onError) => {
  fetch(url, { method: 'GET', headers: getAuthHeaders() })
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const disposition = res.headers.get('content-disposition') || ''
      return res.blob().then((blob) => ({ blob, disposition }))
    })
    .then(({ blob, disposition }) => {
      onSuccess && onSuccess({ data: blob, headers: { 'content-disposition': disposition } })
    })
    .catch((err) => {
      console.error('[UploadService.fetchBlob]', err)
      onError && onError(err)
    })
}

const UploadService = {
  uploadUrl: UaeMpciApiUrls.EXCEL_UPLOAD_POST,
  listUrl: UaeMpciApiUrls.EXCEL_UPLOAD_LIST,
  templateDownloadUrl: UaeMpciApiUrls.EXCEL_UPLOAD_TEMPLATE_DOWNLOAD,
  reportUrl: UaeMpciApiUrls.EXCEL_UPLOAD_REPORT,

    upload: (data, securedSendRequest, onSuccess, onError) => {
    securedSendRequest.execute(
      'POST',
      UaeMpciApiUrls.EXCEL_UPLOAD_POST,
      data,
      (response) => onSuccess && onSuccess(response.data),
      (error) => onError && onError(error),
      () => {},
      { headers: { 'Content-Type': 'multipart/form-data' } },
      null
    )
  },

          downloadTemplate: (_securedSendRequest, onSuccess, onError) => {
    fetchBlob(UaeMpciApiUrls.EXCEL_UPLOAD_TEMPLATE_DOWNLOAD, onSuccess, onError)
  },

    /**
   * Download Excel template by key.
   * @param {'UPLOAD'|'UPDATE'} templateKey
   */
  downloadTemplateByKey: (templateKey, _securedSendRequest, onSuccess, onError) => {
    const url = `${UaeMpciApiUrls.EXCEL_UPLOAD_TEMPLATE_DOWNLOAD}?templateKey=${encodeURIComponent(templateKey)}`
    fetchBlob(url, onSuccess, onError)
  },

      downloadErrorFile: (id, _securedSendRequest, onSuccess, onError) => {
    const url = `${UaeMpciApiUrls.EXCEL_UPLOAD_ERROR_FILE}/${id}`
    fetchBlob(url, onSuccess, onError)
  },

  downloadFile: (id, _securedSendRequest, onSuccess, onError) => {
    const url = `${UaeMpciApiUrls.EXCEL_UPLOAD_DOWNLOAD_FILE}/${id}`
    fetchBlob(url, onSuccess, onError)
  },

  /**
   * POST /bill-upload/submit-drafts
   * Payload: { fileUploadId }
   */
  submitDrafts: (fileUploadId, securedSendRequest, onSuccess, onError) => {
    console.time('[UploadService.submitDrafts]')
    securedSendRequest.execute(
      'POST',
      UaeMpciApiUrls.EXCEL_UPLOAD_SUBMIT_DRAFTS,
      { fileUploadId },
      (response) => {
        console.timeEnd('[UploadService.submitDrafts]')
        onSuccess && onSuccess(response.data)
      },
      (error) => {
        console.timeEnd('[UploadService.submitDrafts]')
        onError && onError(error)
      },
      () => {},
      {},
      null
    )
  },

  /**
   * POST /bill-upload/edit-drafts  (multipart)
   * Payload: FormData { fileUploadId, file }
   */
  editDrafts: (formData, securedSendRequest, onSuccess, onError) => {
    console.time('[UploadService.editDrafts]')
    securedSendRequest.execute(
      'POST',
      UaeMpciApiUrls.EXCEL_UPLOAD_EDIT_DRAFTS,
      formData,
      (response) => {
        console.timeEnd('[UploadService.editDrafts]')
        onSuccess && onSuccess(response.data)
      },
      (error) => {
        console.timeEnd('[UploadService.editDrafts]')
        onError && onError(error)
      },
      () => {},
      { headers: { 'Content-Type': 'multipart/form-data' } },
      null
    )
  },

  /**
   * POST /bill-upload/delete-drafts
   * Payload: { fileUploadId }
   */
  deleteDrafts: (fileUploadId, securedSendRequest, onSuccess, onError) => {
    console.time('[UploadService.deleteDrafts]')
    securedSendRequest.execute(
      'POST',
      UaeMpciApiUrls.EXCEL_UPLOAD_DELETE_DRAFTS,
      { fileUploadId },
      (response) => {
        console.timeEnd('[UploadService.deleteDrafts]')
        onSuccess && onSuccess(response.data)
      },
      (error) => {
        console.timeEnd('[UploadService.deleteDrafts]')
        onError && onError(error)
      },
      () => {},
      {},
      null
    )
  },

  downloadReport: (params, securedSendRequest, onSuccess, onError) => {
    securedSendRequest.execute(
      'GET',
      `${UaeMpciApiUrls.EXCEL_UPLOAD_REPORT}?${new URLSearchParams(params).toString()}`,
      null,
      (response) => onSuccess && onSuccess(response.data),
      (error) => onError && onError(error),
      () => {},
      {},
      null
    )
  }
}

export default UploadService